import type { ScriptWorkflowSteps } from '@/types/workflow';

/**
 * Highest completed workflow milestone — mirrors workflow steps 01–04.
 * Uploaded → Analysed → Scorecard Complete → Rebuild Complete
 */
export function workflowStatusLabel(steps: ScriptWorkflowSteps): string {
  if (steps.rebuild === 'complete') return 'Rebuild Complete';
  if (steps.generate_scorecard === 'complete') return 'Scorecard Complete';
  if (steps.analyse === 'complete') return 'Analysed';
  if (steps.upload === 'complete') return 'Uploaded';
  return 'Not started';
}

/** Scorecard Complete or Rebuild Complete — shown in the Completed section on Home. */
export function isWorkflowCompleted(steps: ScriptWorkflowSteps): boolean {
  return steps.generate_scorecard === 'complete' || steps.rebuild === 'complete';
}

export function formatAggregateScore(overall: number | undefined | null): string | null {
  if (overall == null || Number.isNaN(overall)) return null;
  return (overall / 10).toFixed(1);
}
